const DEISection = () => (
  <>
    <section className="grid__container">
      <div className="grid__row content-block">
        <div className="grid__column--padded grid__column--tablet-12">
          <h2>A workplace for everyone</h2>
          <p>
            We know that Skyscanner will be strongest when our team is both
            inclusive and diverse. So, we&apos;ve committed to eliminating
            biases, removing obstacles to inclusion and ensuring that all our
            people can thrive. We aim to be a workplace where all our people are
            represented, belong and feel empowered. By the end of 2025, our goal
            is that 90% of employees say they feel that people from all
            backgrounds are treated fairly at Skyscanner.
          </p>
        </div>
      </div>
    </section>
    <section className="grid__container page__section">
      <div className="grid__row row--top-align content-block">
        <div className="grid__column--6 grid__column--tablet-12 photo-container">
          <img
            className="photo"
            alt="Four employees collaborating"
            src="https://content.skyscnr.com/m/422d58c668519087/original/dei1v2.png?imbypass=true"
          />
        </div>
        <div className="grid__column--6 grid__column--tablet-12">
          <h2 id="index-section2-header">
            Diversity, Equity and Inclusion in action
          </h2>
          <p id="index-section2-body">
            We have a range of very active employee networks, who are dedicated
            to representing, inspiring, supporting and empowering our diverse
            workforce. Their successes include building programmes to support
            gender inclusion, introducing disability inclusion tools such as
            literacy support solutions, introducing Quiet Rooms for neurodiverse
            colleagues, developing guidance and training for managers on
            micro-aggression, allyship and bias, and implementing Adjustment
            Passports to name just a few.
          </p>
        </div>
      </div>
    </section>
    <section className="grid__container page__section">
      <div className="grid__row row--top-align">
        <div className="grid__column--6 grid__column--tablet-12 photo-container--left mobile-and-tablet-only">
          <img
            className="photo"
            alt="Two employees hanging out on swings in the office"
            src="https://content.skyscnr.com/m/5da5c58f6046d698/original/dei2v2.jpg?imbypass=true"
          />
        </div>
        <div className="grid__column--6 grid__column--tablet-12">
          <div>
            <p className="no-top-margin">
              Inclusion is embedded into every part of our culture—from how we
              build our products to how we show up for one another. On the
              product side, we&apos;ve introduced Inclusive Design Language
              Guidelines and rolled out inclusive coding standards across our
              engineering teams, ensuring our language and practices reflect our
              values. Throughout the year, we celebrate key moments such as
              Black History Month, International Women&apos;s Day, and the
              International Day of Persons with Disabilities, and we&apos;re
              proud participants in Pride marches around the world. We&apos;re
              proud to be signatories of the <b>Race at Work Charter</b> and are
              working towards Disability Confident Level 2 by the end of 2025.
            </p>
            <p>
              We&apos;re delighted to be named one of{' '}
              <b>The Times Top 50 Employers for Gender Equality 2025</b>,
              recognising our commitment to equitable policies, inclusive
              leadership, and progression opportunities. We&apos;ve also been
              awarded Silver in{' '}
              <b>Stonewall&apos;s Global Workplace Equality Index</b>, which
              highlights our continued efforts to support LGBTQ+ inclusion
              globally. These recognitions are milestones on our ongoing journey
              to build a truly inclusive, supportive, and equitable workplace
              for all.
            </p>
          </div>
        </div>
        <div className="grid__column--6 grid__column--tablet-12 photo-container--right">
          <img
            className="photo desktop-only"
            alt="Two employees hanging out on swings"
            src="https://content.skyscnr.com/m/5da5c58f6046d698/original/dei2v2.jpg?imbypass=true"
          />
        </div>
      </div>
    </section>
    <section className="grid__container">
      <div className="video-container--landscape">
        <video
          className="video"
          controls
          src="https://content.skyscnr.com/m/57840444f63e8c95/original/Engineering-Amber-Hero-16x9-lockup-subs-V2.mp4"
          width="100%"
          poster="https://content.skyscnr.com/m/221c0e73c1380a18/original/jobs-diversity-video-thumbnail.png?imbypass=true"
        >
          <track
            src="../transcripts/Skyscanner-Amber-Hero-16x9-lockup-subs V2-en-US.vtt"
            kind="captions"
            label="English"
          />
        </video>
      </div>
      <hr aria-hidden="true" />
    </section>
    <section className="grid__container">
      <div className="grid__row row--top-align content-block">
        <div className="grid__column--5 grid__column--tablet-12 photo-container">
          <img
            className="photo"
            alt="Myra Fulton"
            src="https://content.skyscnr.com/m/225e996797ca7b9c/original/myra-photo.png?imbypass=true"
          />
        </div>
        <div className="grid__column--7 grid__column--tablet-12">
          <p className="quote no-top-margin">
            “We talk a lot about creating the right environment at Skyscanner.
            As a woman in tech, working here has been a great experience.
            I&apos;ve had a lot of opportunities that I wouldn&apos;t have had
            elsewhere so now I&apos;m passionate about showing that this pathway
            is possible and ensuring women can see a successful career path in
            tech.”
          </p>
          <p className="sub-heading">Myra Fulton, VP Engineering</p>
        </div>
      </div>
      <hr aria-hidden="true" />
    </section>
  </>
);

export default DEISection;
